import { AvailablePlan } from '@/data/services/plan/plan-service-types'
import { Account } from '@/domain/usecases'

const sortByIdAsc = (plans: AvailablePlan[]): AvailablePlan[] =>
  [...plans].sort((a, b) => a.id - b.id)

export const getAvailablePlans = (
  plans: AvailablePlan[],
  showFullCatalog: boolean,
  account: Account.Model,
  allowedPlanIds?: number[]
): AvailablePlan[] => {
  if (showFullCatalog) {
    return sortByIdAsc(
      allowedPlanIds ? plans.filter(planItem => allowedPlanIds.includes(planItem.id)) : plans
    )
  }

  const userPlanId = Number(account.passPlan?.id)
  return sortByIdAsc(plans.filter(planItem => planItem.id >= userPlanId))
}
